import { api, auth } from '@/f1/service';
import moment from 'moment-timezone';
import DatePicker from 'vue2-datepicker'
import custom from '@/f1/custom';
import _ from 'lodash'
import Language from './language';
import RuleCountry from '@/f1/views/WebCastle/modules/Rule.Country.i18n'
import ruleI18n from '../rule.i18n' // 정책 번영 파일 추가
import reg from '@/f1/reg'
import Multiselect from 'vue-multiselect'
import 'flag-icon-css/css/flag-icon.css';
import Bell from 'vue-notification-bell'
import Detail from '../Log.Detail.i18n';
import punycode from 'punycode/'
import { Switch as cSwitch } from '@coreui/vue'

const default_opt = () => ({
  perPage: 10,
  currentPage: 1, totalRows: 0,
  sk: '', sv: '', skt: '', opt : {}, adv : false,
  created_at_ed : moment().add(1, 'day'),
  created_at_sd : moment().add(-1, 'day'),
});
let i18n_fields = {
  EN: [
    { key: 'id', label: 'No.', sortable: true, thStyle: 'width: 5%', option : 1 },
    { key: 'created_at', label: 'DateTime', sortable: true, thStyle: 'width: 8%', option : 0 },
    // { key: 'country', label: 'Country', sortable: true, thStyle: 'width: 4%', option : 0 },
    { key: 'remote_addr', label: 'Attacker( => )', sortable: true, thStyle: 'width: 15%', option : 0 },
    { key: 'agent.nickname', label: 'Nickname', sortable: true, thStyle: 'width: 5%', option : 2 },
    { key: 'target', label: 'Victim', sortable: true, option : 0 },
    { key: 'host', label: 'Host', sortable: true, thStyle: 'width: 5%', option : 0 },
    { key: 'is_block', label: 'Response', sortable: false, option : 0 },
    { key: 'message', label: 'Message', sortable: false, option : 0 },
    { key: 'severity', label: 'Risk', sortable: false, option : 0 },
    { key: 'protocol', label: 'Protocol', sortable: false, option : 3 },
    { key: 'uri', label: 'URI', sortable: false, option : 4 },
    // { key: 'func', label: 'More', sortable: false, thStyle: 'width: 8%', option : -2  },
  ],
  KO: [
    { key: 'id', label: 'No.', sortable: true, thStyle: 'width: 5%', option : 1 },
    { key: 'created_at', label: '탐지시간', sortable: true, thStyle: 'width: 8%', option : 0 },
    // { key: 'country', label: '국가', sortable: true, thStyle: 'width: 4%', option : 0 },
    { key: 'remote_addr', label: '공격자( => )', sortable: true, thStyle: 'width: 15%', option : 0 },
    { key: 'agent.nickname', label: '이름', sortable: true, thStyle: 'width: 5%', option : 2 },
    { key: 'target', label: '공격 대상', sortable: true, option : 0 },
    { key: 'host', label: '호스트', sortable: true, thStyle: 'width: 5%', option : 0 },
    { key: 'is_block', label: '응답', sortable: false, option : 0 },
    { key: 'message', label: '메세지', sortable: false, option : 0 },
    { key: 'severity', label: '위험', sortable: false, option : 0 },
    { key: 'protocol', label: '프로토콜', sortable: false, option : 3 },
    { key: 'uri', label: 'URI', sortable: false, option : 4 },
    // { key: 'func', label: '더 보기', sortable: false, thStyle: 'width: 8%', option : -2  },
  ]
}
// const _i18n_data = {
//   username: {
//     EN : () => `Username required.`,
//     KO : () => `아이디를 입력하세요.`,
//   },
//   password: {
//     EN : () => `Password required.`,
//     KO : () => `비밀번호를 입력하세요.`,
//   }
// };
export default {
  props : ['only_view', 'auto_refresh', 'agent_id_list'],
  data: () => {
    return {
      moment,
      log_id : 0,
      is_half_mode : false,
      country_code : [],
      use_geoip : true,
      info_xff : false,
      ruleI18n,
      extra : false,
      th : undefined,
      custom,
      show: true,
      auth : auth,
      so : default_opt(),
      sync : { interval : 15, run : false },
      selected : [],
      options: [],
      agent_list : [],
      agent : undefined,
      max_width : 1700,
    }
  },
  components: { Language, DatePicker, Multiselect, RuleCountry, Bell, Detail, cSwitch },
  computed: {
    can_split_view: function() { return window.innerWidth > this.max_width },
    id : function() { return this.log_id; },
    startRow : function() {
      return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage;
    },
    fields() {
      return _.map(i18n_fields[this.i18n], f => {
        if(f.option < -1) {
          if(this.only_view != true) { return f }
        }
        else if(_.indexOf(this.selected, f.option) > -1 || f.option < 1) {
          return f
        }
      })
    }
  },
  methods: {
    set_flag(x) { return x ? `flag-icon flag-icon-${x.toLowerCase()}` : '' },
    download() {
      // 향후 엑셀 다운로드로 변경 필요
      let start_date = this.so.created_at_sd && moment(this.so.created_at_sd)
      let range = moment.duration((this.so.created_at_ed && moment(this.so.created_at_ed)).diff(start_date)).asMonths()
      // console.log('range month is', range)

      if(range > 6) { return this.$toastr.w("download range is too long") }
      // 다운로드의 경우 3개월 단위로만 다운로드가 가능해야 함

      let search = this.search_option({}, true);
      api.webcastle.WebCastle(Object.assign({}, search, { target : 'log', cmd : 'download' })).then(rs => {
        if(!rs.body) { return this.$toastr.w('no have data') }

        // "Agent", "Agent ip", "DateTime(UTC)", "target", "host", "m_id", "message", "severity", "method", "protocol", "attacker", "country", "request", "response(block)"

        var blob = new Blob(["\ufeff"].concat(_.map(rs.body, x => {

          // console.log(index, x[12])
          try {
            if(x[6] != 'message') {
              // console.log(x[6])

              let msg = _.minBy(JSON.parse(x[6]).messages, z => z.details.severity)
              x[5] = msg.details.ruleId
              // x[6] = msg.message
              x[7] = msg.details.severity

              x[6] = `"${x[6].replace(/"/g, '""')}"` // json 데이터 이슈
            }

            if(x[12] != 'request') {
              // request 부분 공격 부분이 잘못 필터링 됨
              x[12] = `"${x[12].replace(/"/g, '""')}"` // json 데이터 이슈
            }

            return x.concat('\r')
          } catch (e) {
            console.log(e)
          }
        })));
        let link = document.createElement('a')
        link.style.visibility = 'hidden';
        link.href = window.URL.createObjectURL(blob)
        link.download = 'UWSS_WebCastle_detect_log.csv'
        link.click()

      }).catch(error => {
        console.error(error)
        this.$toastr.w('download failed!!')
      })
    },
    add_country (newTag) { this.country_list.push(newTag) && this.country.push(newTag.agent_id) },
    add_tag (newTag) { this.agent_list.push(newTag) && this.agent.push(newTag.agent_id) },
    reload() { this.$refs._wc_log_list && this.$refs._wc_log_list.refresh() },
    is_block(messages) {
      return !_.startsWith(messages.toLowerCase(), 'detectiononly')
    },
    search_opt() {
      this.so.adv = !this.so.adv;
      if(this.so.adv) {
        // this.so.opt['paid_at_ed'] = moment().add(1, "day").startOf('d');
        // this.so.opt['refund_at_ed'] = moment().add(1, "day").startOf('d');
        // this.so.opt['match_type'] = 'and';
        this.so.opt['remote_addr_check'] = false;
        this.so.opt['target_check'] = false;
        this.so.opt['message_check'] = false;
        this.so.opt['xff_check'] = false;
        this.so.opt['match_type'] = 'and';
        this.so.opt['method'] = ''
        this.so.opt['is_block'] = ''
        this.so.sv = '';
      } else { this.reset(); }
    },
    autoSize : function() { return Number(window.innerWidth / 100) * 2 },
    reset() { this.so = default_opt(); this.reload(); },
    refresh() {
      if(this.sync.run) {
        this.$refs && this.$refs._wc_log_list ? this.$refs._wc_log_list.refresh() : ''
        console.log('refresh list')
      }
      clearTimeout(this.th)
      this.th = undefined
      this.th = setTimeout(this.refresh, 1000 * this.sync.interval)
    },
    getRowCount () { return this.so.totalRows || 0; },
    getItems: function(ctx) { return this.load(ctx); },
    getAgentList: function() {
      if(this.only_view == true) { return console.log('is only view') }

      api.webcastle.WebCastle({ target : 'agent', cmd : 'list.info' }).then(rs => {
        this.agent_list = []
        rs.body ? rs.body.forEach(agent => this.agent_list.push(agent)) : ''

      }).catch(error => console.error(error))
    },
    set_op(k, v, op=undefined) {
      if(op) { return { name : k, value : v, op : op }; }
      else if(k.endsWith('_check')) { return '' }

      v = v.trim()

      switch (k) {

        // case 'uri' : return { name : 'uri', value : `%${v}%`, op : 'like'};
        case 'method' : return { name : 'method', value : v, op : '='};
        case 'is_block' :
          if(!v) { return '' }
          return { name : 'is_block', value : v == 'false' ? false : true, op : '='};
        case 'm_id' : return { name : 'm_id', value : v ? Number(v) : '', op : '='};
        case 'm_line' : return { name : 'm_line', value : Number(v), op : '='};
        case 'created_at_sd' : return { name: 'created_at', value: moment(v).valueOf(), op: '>=' };
        case 'created_at_ed' : return { name: 'created_at', value: moment(v).add(1, 'd').valueOf(), op: '<=' };
        case 'last_visit_sd' : return { name: 'last_visit', value: moment(v).valueOf(), op: '>=' };
        case 'last_visit_ed' : return { name: 'last_visit', value: moment(v).add(1, 'd').valueOf(), op: '<=' };

        // case 'uri' : return;
        case 'xff':
          if(this.so.opt['xff'] && !reg.ip4.test(this.so.opt['xff'])) { return this.$toastr.w('XFF is not ip format') }

          if(this.so.opt.xff_check) {
            if(!v) { return { msg : 'check attacker search option'} }
            if(!reg.ip4.test(v)) { return { msg : 'XFF is not ip format'} }
            return { name : 'headers', value : [v], op : 'not in' }
          } else {
            return { name : 'headers', value : `%${v}%`, op : 'like' }
          }

        case 'remote_addr':
          if(this.so.opt.remote_addr_check) {
            if(!v) { return { msg : 'check attacker search option'} }
            return { name : 'remote_addr', value : [v], op : 'not in'} ;
          } else {
            return { name : 'remote_addr', value : v, op : '=' }
          }
        case 'target':
          if(this.so.opt.target_check) {
            if(!v) { return { msg : 'check Victim search option'} }
            return { name : 'target', value : [v], op : 'not in' }
          } else {
            return { name : 'target', value : v, op : '=' }
          }

        case 'message':
          // 메세지의 경우, 룰 아이디로 치환하여 검색
          return _.compact(_.map(Object.keys(this.ruleI18n), k => {
            if((this.ruleI18n[k].ENG && this.ruleI18n[k].ENG.indexOf(v) > -1) || (this.ruleI18n[k].KOR && this.ruleI18n[k].KOR.indexOf(v) > -1)) {
              return this.so.opt.message_check ?
               { name : 'm_id', value : [Number(k)], op : 'not in' } :
                { name : 'm_id', value : Number(k), op : '=' }
              }
          }))

        case 'uri':
          if(this.so.opt.uri_check) {
            if(!this.so.opt['uri']) { return { msg : 'check uri search option'} }
            return { name : 'uri', value : `%${this.so.opt['uri']}%`, op : 'not like' }
          } else {
            return { name : 'uri', value : `%${v}%`, op : 'like' }
          }
        default:
          console.log('default', k, v, op)
          if(v === "false" || v === "true") { return { name : k, value : v === "false" ? false : true, op : '=' }  }
          return { name : k, value : `%${v}%`, op : 'like' }
      }
    },
    search_option(ctx = {}, is_range_foramt=false) {
      let so = {
        ok : ctx.sortBy,
        // od : ctx.sortDesc ? 'd' : 'a',
        pg : ctx.currentPage || this.so.currentPage || 1,
        pc : ctx.perPage || this.so.perPage || 10,
        sk : this.so.sk,
        sv : this.so.sv,
        opt: this.so.adv ? Object.assign({}, this.so.opt) : {},
        target : 'log', cmd : 'list'
      }
      var search = { limit: so.pc, offset: (so.pg - 1) * so.pc, target : so.target, cmd : so.cmd, body: { and: [{ name : 'is_del', value:false, op: '='}], or: [], sort: [] } };

      // set sort
      if(so.sortBy) { search.body.sort = [ { name : so.sortBy, op : ctx.sortDesc && 'desc' } ]; }
      if(!is_range_foramt) { search.body.sort.push({ name : 'id', op : 'desc'}) }

      // 모듈로 에이전트 선택할 경우
      if(this.agent_id_list) {
        for (let i = 0; i < this.agent_id_list.length; i++) {
          let id = typeof this.agent_id_list[i] == 'object' ? this.agent_id_list[i].id : this.agent_id_list[i]
          id ? search.body.or.push({ name : 'agent_id', value : id, op : '='}) : ''
        }
      }

      // 목록에서 에이전트 선택했을 경우
      if(this.agent) {
        for (let i = 0; i < this.agent.length; i++) {
          search.body.or.push({ name : 'agent_id', value : this.agent[i].agent_id, op : '='})
        }
      }

      if(this.so.sk && (this.so.sv || '').trim()) {
        let cond = this.set_op(this.so.sk, this.so.sv)
        Array.isArray(cond) ? cond.forEach(x => search.body.and.push(x)) : search.body.and.push(cond)
      }
      if(this.so.created_at_ed) { search.body.and.push(this.set_op('created_at', moment(this.so.created_at_ed).format('YYYY-MM-DD'), '<=')) }
      if(this.so.created_at_sd) { search.body.and.push(this.set_op('created_at', moment(this.so.created_at_sd).format('YYYY-MM-DD'), '>=')) }

      if(this.so.adv && this.so.opt) {
        // 국가를 지정했을 경우
        if(this.country_code) {
          console.log('country_code', this.country_code.length)
          for (let i = 0; i < this.country_code.length; i++) {
            search.body.or.push({ name : 'country', value : this.country_code[i], op : '='})
          }
        }

        var k = Object.keys(this.so.opt)
        if(k.indexOf('xff') > -1) {
          // search.body.and.push({ name : 'headers', value : '%x-forwarded-for%', op : 'like' })
          search.body.and.push({ name : 'headers', value : [`%X-Forwarded-For: ${this.so.opt['xff']}%`], op : 'not in' })
        }
        for (let i = 0; i < k.length; i++) {
          if(k[i] == 'match_type') { continue; }
          let cond = this.set_op(k[i], this.so.opt[k[i]]);

          if(Array.isArray(cond)) {
            cond.forEach(c => {
              if(!c || c.value == '%%' || c.value === '') { return; }
              else { this.so.opt['match_type'] == "and" ? search.body.and.push(c) : search.body.or.push(c) }
            })
            continue
          }
          if(cond.msg) { return this.$toastr.w(cond.msg) }
          else if(!cond || cond.value == '%%' || cond.value === '') { continue; }
          else { this.so.opt['match_type'] == "and" ? search.body.and.push(cond) : search.body.or.push(cond) }
        }
      }

      return search
    },
    load(ctx = {}) {
      try {
        let search = this.search_option(ctx);

        return api.webcastle.WebCastle(search).then(rs => {
          this.so.totalRows = rs.total;
          this.options = []
            i18n_fields[this.i18n].forEach(r => {
              if(r.option < 1) { return }
              this.options.push({ text: r.label, value: r.option })
            });

          if(rs.body && rs.body.length > 0){

            return _.map(rs.body, r => {
              try { r.message = JSON.parse(r.message) }
              catch (e) {
                console.log(r.message)
                console.log("json parser failed");
                r.is_failed = true;
                return r;
              }
              // 메세지 앞에 탐지한 구문이 있을 경우, 탐지만으로 설정, 패턴 N 개 매칭으로 인한 코드 추가
              r.detect_cnt = _.filter(r.message.messages, x => _.startsWith(x.message.toLowerCase(), '[detectiononly]')).length
              r.block_cnt = r.message.messages.length - r.detect_cnt
              r.summary = _.minBy(r.message.messages, function(x) { return Number(x.details.severity) })

              _.forEach(r.headers ? r.headers.split('\n') : [], line => {
                let ip = line.replace(/(x-forwarded-for:| )/ig, '')
                _.startsWith(line.toLowerCase(), 'x-forwarded-for') && reg.ip4.test(ip) ? (r.xff = ip) : ''
              })

              // https://github.com/mathiasbynens/punycode.js
              // 기본 라이브러리 punycode 는 사용 불가
              if(_.startsWith(r.target, 'xn--')) { r.target = punycode.toUnicode(r.target) }
              if(_.startsWith(r.host, 'xn--')) { r.host = punycode.toUnicode(r.host) }

              return r
            })
          }
          return rs.body;
        }).catch(e => {
          console.log(e)
          this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText)
        });
      } catch (e) {
        console.log(e)
      }
    },
    pause: function() { this.sync.run = !this.sync.run; this.refresh(); },
    detail: function(item) {
      if(!this.is_half_mode) {
        console.log(item); this.$router.push(`log/${item.id}`);
        return
      }

      this.log_id = item.id
      // 사이즈가 작을 경우에만 실행

      // if(window.screen.width < 1400) {
      //   this.i18n_fields[this.i18n][4].option = 5
      //   // this.i18n_fields[this.i18n][4].option = 6
      // }


    },
  	// hideList: function(e) {
    //   this.show = !e; console.log('webcastle', 'log.vue', 'got event (list show/hide)', !e ? 'show' : 'hide')
  	// }
  },
  created: function() {   console.log('webcastle', 'log.vue', 'created'); },
  destroyed: function() { console.log('webcastle', 'log.vue', 'destroyed'); clearTimeout(this.th); this.th = undefined},
  mounted: function() { console.log('webcastle', 'log.vue', 'mounted'); this.getAgentList() },
}
